export default __webpack_public_path__ + "static/media/Price_And_Shipping_Update_Summary_13112025.dda25db5.zip";